import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificado',
  templateUrl: './certificado.component.html',
  styleUrls: ['./certificado.component.css']
})
export class CertificadoComponent implements OnInit {
  oculto: boolean = false;
  icon4: boolean = false;
  icon3: boolean = false;
  icon2:boolean = false;
  icon1:boolean=false;
  alertaapto:boolean=false;

  alertanaoapto:boolean=false;

  constructor() { }

  ngOnInit(): void {
  }

  abrirManual(){

  }

  abrirAdesao(){

  }

  solictarSelo(){
    
  }

}
